import DialogActions from '@material-ui/core/DialogActions'

export default DialogActions
